// init
import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';

// external elements
import VueMobileDetection from 'vue-mobile-detection';
import VueNumberFormat from 'vue-number-format';

// page load components
import ArticleSection from '@/components/articles/shared/ArticleSection.vue';
import StyleGuideButton from '@/components/shared/StyleGuideButton.vue';
import ArticleBase from '@/components/articles/shared/ArticleBase.vue';

createApp(App)
  .use(store)
  .use(router)
  .use(VueMobileDetection)
  .use(VueNumberFormat, {
    prefix: '',
    decimal: ',',
    thousand: '.',
    acceptNegative: false,
    isInteger: true,
  })
  .component('ArticleSection', ArticleSection)
  .component('StyleGuideButton', StyleGuideButton)
  .component('ArticleBase', ArticleBase)
  .mount('#app');
